export default __webpack_public_path__ + "bg_anli_shouji0203548b.png";